<template lang="html">
  <div class="sc container" @click.stop="">
    <transition name="fade" mode="out-in">
      <div class="sc__box full-width full-height padding-20 container column justify-center align-center" v-if="step === 0">
        <div class="sc__box__title align-center">
          <h3>Por favor, escolha o dia para agendar sua <span>{{ (isComplementary ? lessons[nextIndex] : currentClass).lesson_name }}</span></h3>
        </div>
        <div class="sc__box__options align-center" v-if="(currentClass && currentClass.type == 'U') && !toReview.length">
          <button class="btn btn-full btn-rounded margin-right-10" type="button" name="button" :class="{ 'active-button': !isComplementary }" @click="setComplementary(false)">{{ currentClass.lesson_name }}</button>
          <button class="btn btn-full btn-rounded" type="button" name="button" :class="{ 'active-button': isComplementary }" @click="setComplementary(true)">{{ lessons[nextIndex].lesson_name }}</button>
        </div>
        <div class="sc__box__items container">
          <div class="sc__box__items__btn container justify-center align-center padding-10" :class="{ disabled: !allowBack }" @click="prevPage()">
            <font-awesome-icon icon="caret-left"/>
          </div>
          <div class="sc__box__items__slick container wrap align-center padding-10">
            <div class="sc__box__items__slick__item padding-10 container align-center" v-for="(s, index) in schedule" @click="setSchedule(s)" :key="index">
              <div class="sc__box__items__slick__item__content padding-10 container align-center" :class="{ selected: (!!toSchedule && (toSchedule.class_id == s.class_id) && !!s.date) }" >
                <div class="sc__box__items__slick__item__content__line">
                </div>
                <div class="sc__box__items__slick__item__content__info container column align-center">
                  <div class="sc__box__items__slick__item__content__info__date">
                    <span>{{ getDate(s.date).day }}</span>/{{ getDate(s.date).month }}
                  </div>
                  <div class="sc__box__items__slick__item__content__info__day">
                    {{ getDay(s.date) }}
                  </div>
                  <div class="sc__box__items__slick__item__content__info__time">
                    {{ getTime(s.date) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sc__box__items__btn container justify-center align-center padding-10" :class="{ disabled: !allowNext }" @click="nextPage()">
            <font-awesome-icon icon="caret-right"/>
          </div>
        </div>
        <div class="sc__box__footer container align-center margin-10">
          <button type="button" name="button" style="width: 200px;" class="btn btn-full btn-gradient-red btn-rounded margin-right-10" @click="close()">Close</button>
          <button type="button" name="button" style="width: 200px;" class="btn btn-full btn-gradient-green btn-rounded" :class="{ disabled: !toSchedule }" @click="nextStep()" :disabled="!toSchedule">Next</button>
        </div>
      </div>
      <div class="sc__box full-width full-height padding-20 container column justify-center align-center padding-20" v-else-if="step === 1">
        <div class="sc__box__title">
          <h3><span>CONFIRM</span> YOUR CLASS</h3>
        </div>
        <div class="sc__box__items container column padding-10">
          <div class="sc__box__items__content container align-center">

            <div class="sc__box__items__content__unit container column align-center justify-center">
              <span>class</span>
              <p> {{ (isComplementary ? lessons[nextIndex] : currentClass).lesson_name }} </p>
            </div>
            <div class="sc__box__items__content__date container column align-center justify-center">
              <span>Day</span>
              <p>{{ getDate(toSchedule.date).day }}/{{ getDate(toSchedule.date).month }}</p>
            </div>

            <div class="sc__box__items__content__day container column align-center justify-center margin-left-10">

              <div class="sc__box__items__content__day__title justify-center align-center">
                {{ getDay(toSchedule.date) }}
              </div>

              <div class="sc__box__items__content__day__time justify-center align-center">
                {{ getTime(toSchedule.date) }}
              </div>
            </div>
          </div>
          <div class="sc__box__items__content__confirmtext">
            You Scheduled a class, day {{ getDate(toSchedule.date).day }}, of {{ getMonth(toSchedule.date) }}, for {{ (isComplementary ? lessons[nextIndex] : currentClass).lesson_name }}. Is this information correct?
          </div>
        </div>
        <div class="sc__box__footer align-center">
          <button type="button" name="button" style="width: 200px;" class="btn btn-full btn-gradient-red btn-rounded margin-right-10" @click="close()">Cancel</button>
          <button type="button" name="button" style="width: 200px;" class="btn btn-full btn-gradient-green btn-rounded" @click="confirmSchedule()">Confirm</button>
        </div>
      </div>
      <div class="sc__box full-width full-height padding-20 container column justify-center align-center padding-20" v-else-if="step === 2">
        <div class="sc__box__title">
          <h3 v-if="!error">YOUR CLASS WAS SCHEDULED <span>SUCCESSFULLY</span></h3>
          <h3 v-else>SCHEDULING <span>FAILED</span></h3>
        </div>
        <div class="sc__box__items container column justify-center align-center padding-10">
          <div class="sc__box__feedback justify-center align-center">
            <!-- {{ !error ? 'Ok' : 'Error' }} -->
            <img src="@/assets/img/icons/check.svg" alt="Check" v-if="!error">
            <img src="@/assets/img/icons/cancel.svg" alt="Cancel" v-else>
          </div>
          <div class="sc__box__coins justify-center align-center">
            <img src="@/assets/img/coin.svg" alt="Check">
            <p v-if="!error">You won <span>3 coin</span></p>
            <p v-else><strong>{{ error.message || 'Failed to schedule class' }}</strong></p>
          </div>
        </div>
        <div class="sc__box__footer align-center">
          <button type="button" name="button" style="width: 200px;" class="btn btn-full btn-gradient-red btn-rounded" @click="close()">CLOSE</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ScheduleClass',
  data () {
    return {
      step: 0,
      page: 0,
      toSchedule: null,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      error: null,
      isComplementary: false
    }
  },
  props: {
    close: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      'student': 'student/GET',
      'lessons': 'lesson/getLessons',
      'toReview': 'lesson/getReview',
      '_schedule_': 'lesson/schedule',
      '_nextSchedule_': 'lesson/nextSchedule'
    }),
    schedule () {
      const temp = (this.isComplementary ? this._nextSchedule_ : this._schedule_).map(s => {
        const date = new Date(s.DataInicial)
        date.setHours(date.getHours() + 3)

        return {
          class_id: s.CodAgenda,
          date
        }
      }).slice(this.page * 8, 8 * (this.page + 1))

      while (temp.length < 8) {
        temp.push({ date: null })
      }

      return temp
    },
    allowBack () {
      return this.page > 0
    },
    allowNext () {
      return this.page < Math.trunc(this._schedule_.length / 8)
    },
    currentIndex () {
      if (this.toReview.length)
        return this.lessons.findIndex(l => l.lesson_id == this.toReview[0].lesson_id)

      return this.lessons.findIndex(l => (
        l.lesson_id == this.student.lesson_id &&
        l.order == this.student.lesson_order
      ))
    },
    nextIndex () {
      if (this.toReview.length)
        return this.lessons.findIndex(l => l.lesson_id == this.toReview[0].lesson_id)

      return this.lessons.findIndex(l => (
        l.book_id == this.student.book_id &&
        l.order == this.student.lesson_order + 1
      ))
    },
    currentClass () {
      return this.lessons[this.currentIndex]
    }
  },
  methods: {
    getDate (date) {
      if (!date) return { day: '00', month: '00' }

      let day   = date.getUTCDate(),
          month = date.getUTCMonth() + 1

      if (day < 10)   day   = `0${day}`
      if (month < 10) month = `0${month}`

      return { day, month }
    },
    getDay (date) {
      if (!date) return 'None'
      return this.days[date.getDay()]
    },
    getMonth (date) {
      if (!date) return 'None'
      return this.months[date.getMonth()]
    },
    getTime (date) {
      if (!date) return '00:00 a.m.'

      let hours   = date.getHours(),
          minutes = date.getMinutes()

      const isNight = hours > 12

      hours = isNight ? hours % 12 : hours

      if (hours < 10)   hours   = `0${hours}`
      if (minutes < 10) minutes = `0${minutes}`

      return `${hours}:${minutes} ${isNight ? 'p' : 'a'}.m.`
    },
    nextPage () {
      if (this.allowNext) this.page++
    },
    prevPage () {
      if (this.allowBack) this.page--
    },
    setSchedule (lesson) {
      if (!!lesson && !!lesson.date) this.toSchedule = lesson
      else this.toSchedule = null
    },
    nextStep () {
      this.step++
    },
    async confirmSchedule () {
      try {
        this.$store.commit('setShowLoader', true)

        await this.$store.dispatch('lesson/schedule', this.toSchedule.class_id)
        await this.$store.dispatch('lesson/getClasses')

        if (this.currentClass.type == 'U' && !this.toReview.length)
          await this.$store.dispatch('lesson/getNextSchedule')
        else
          await this.$store.dispatch('lesson/getSchedule')
      } catch (error) {
        this.error = error
      } finally {
        this.toSchedule = null
        this.$store.commit('setShowLoader', false)
        this.nextStep()
      }
    },
    setComplementary (isComplementary) {
      this.isComplementary = isComplementary
      this.toSchedule = null
    }
  },
  async beforeCreate () {
    await this.$store.dispatch('lesson/getSchedule')
  },
  async mounted () {
    if (this.currentClass.type == 'U' && !this.toReview.length)
      await this.$store.dispatch('lesson/getNextSchedule')
  }
}
</script>

<style lang="scss" scoped>
  .sc {
    max-height: 570px;
    max-width: 780px;
    min-height: 485px;
    &__box {
      flex: 1;
      background-color: #FEFEFE;
      border-radius: 25px;
      align-self: stretch;
      &__title {
        flex-grow: 1;
        padding: 25px 20px;
        h3 {
          padding: 0px 100px;
          text-align: center;
          color: #1474BC;
          font-size: 30px;
          span{
            color: #FF7700;
            font-weight: 400;
          }
        }
      }
      &__options {
        flex-grow: 1;
        button.btn {
          background-color: #FF9C00;
          font-size: 22px;
          padding: 10px 25px;
          &.active-button {
            background-color: lighten(#FF9C00, 25);
          }
        }
      }
      &__items {
        flex-grow: 2;
        &__btn {
          border-radius: 7.25px;
          background-color: #DFDFDF;
          margin: 20px 0;
          &.disabled {
            cursor: not-allowed;
            background-color: #EFEFEF;
            color: #BBB;
          }
        }
        &__slick {
          justify-content: stretch;
          &__item {
            flex-basis: 25%;
            align-self: stretch;
            justify-content: center;
            width: 145px;
            height: 155px;
            &__content {
              align-self: stretch;
              width: 100%;
              background-color: #DFDFDF;
              justify-content: center;
              border-radius: 15px;
              transition: all .2s;
              &:hover, &:active {
                cursor: pointer;
                background-color: #CCC;
              }
              &.selected {
                background-color: #FFA200;
                .sc__box__items__slick__item__content {
                  &__line {
                    background-color: #FFF;
                  }
                  &__info__date, &__info__date span {
                    color: #FFF;
                  }
                }
              }
              &__line {
                background-color: #3DFF8B;
                flex-basis: 7.5px;
                align-self: stretch;
                margin: 5px 5px 5px 0px;
                height: 90%;
                border-radius: 5px;
              }
              &__info {
                flex-grow: 1;

                &__date {
                  font-size: 30px;
                  color: #747474;
                  span {
                    font-size: 40px;
                    color: #949494;
                  }
                }
                &__day {
                  margin-top: 6px;
                  font-size: 14px;
                  color: #FFF;
                  border-radius: 10px;
                  background-color: #A95EFF;
                  padding: 2.5px 7.5px;
                  width: 90%;
                  text-align: center;
                }
                &__time {
                  margin-top: 6px;
                  font-size: 14px;
                  color: #AE5100;
                  border-radius: 10px;
                  background-color: #FFBE3D;
                  padding: 2.5px 7.5px;
                  width: 90%;
                  text-align: center;
                }
              }
            }
          }
        }
        &__content {
          justify-content: center;
          &__unit {
            margin: 5px;
            background-color: #5EFFC8;
            color:#055C77;
            border-radius: 15px;
            font-size: 30px;
            text-transform: uppercase;
            padding: 15px 30px;

            span {
              font-size: 14px;
              font-weight: 400;
            }
          }
          &__date {
            margin: 5px;
            background-color: #055C77;
            color:#5EFFC8;
            border-radius: 15px;
            font-size: 30px;
            font-weight: 300;
            text-transform: uppercase;
            padding: 15px 30px;

            span {
              font-size: 14px;
              font-weight: 400;
            }
          }
          &__day {
            &__title {
              flex: 1;
              background-color: #A95EFF;
              color: white;
              border-radius: 15px;
              border-radius: 300px;
              font-weight: 300;
              padding: 8px 30px;
              margin: 5px;
              width: 100%;
            }
            &__time {
              flex: 1;
              background-color: #FFBE3D;
              color: #AE5100;
              border-radius: 15px;
              border-radius: 300px;
              font-weight: 300;
              padding: 8px 30px;
              margin: 5px;
              width: 100%;
            }
          }
          &__confirmtext{
                  font-size: 18px;
                  padding: 35px 150px;
                  text-align: center;
                  font-weight: 300;
                  color: #8e8e8e;
                  line-height: 30px;
                }
        }
      }
      &__feedback{
        background: #FFAA00;
        width: 400px;
        border-radius: 20px;
        height: 120px;
        position: relative;
        img{
          width: 150px;
          position: absolute;
        }
      }
      &__coins{
        font-size: 18px;
        color: #7B5710;
        padding: 40px 20px;
        flex-direction: column;
        font-weight: 300;
        span{
          font-weight: 400;
        }
        img{
          width: 20px;
        }
      }
      &__footer {
        flex-grow: 1;
        button {
          font-size: 22px;
          padding: 10px 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/scheduleClass/index.vue